import { createContext, useContext, useReducer, useEffect } from "react";

const LayoutContext = createContext(null);

const initialState = {
  isAsideOpen: false,      // mobile aside visible
  isDarkMode: false,
  isAsideMobileOpen: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "ASIDE_TOGGLE":
      return { ...state, isAsideMobileOpen: !state.isAsideMobileOpen };
    case "ASIDE_CLOSE":
      return { ...state, isAsideMobileOpen: false };
    case "DARK_TOGGLE":
      return { ...state, isDarkMode: !state.isDarkMode };
    case "DARK_SET":
      return { ...state, isDarkMode: action.value };
    default:
      return state;
  }
}

export function LayoutProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState, (init) => {
    const stored = localStorage.getItem("darkMode");
    // Default to dark if no preference saved (matches the dark shell)
    const isDarkMode = stored === null ? true : stored === "true";
    return { ...init, isDarkMode };
  });

  // Apply dark class to <html>
  useEffect(() => {
    document.documentElement.classList.toggle("dark", state.isDarkMode);
    localStorage.setItem("darkMode", String(state.isDarkMode));
  }, [state.isDarkMode]);

  const value = {
    isAsideMobileOpen: state.isAsideMobileOpen,
    isDarkMode: state.isDarkMode,
    toggleAside: () => dispatch({ type: "ASIDE_TOGGLE" }),
    closeAside: () => dispatch({ type: "ASIDE_CLOSE" }),
    toggleDark: () => dispatch({ type: "DARK_TOGGLE" }),
  };

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
}

export function useLayout() {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error("useLayout must be used within LayoutProvider");
  return ctx;
}
